export const BASE_URL = process.env.REACT_APP_DATASERVICE;
export const IS_CYPRESS = !!(window as any).Cypress;
export const IS_TEST = process.env.NODE_ENV === "test";
export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const IS_TEST_OR_DEVELOPMENT = ["development", "test"].includes(process.env.NODE_ENV);
export const DEPLOYMENT_ENV = process.env.REACT_APP_DEPLOYMENT_ENV;
export const IS_DEPLOYMENT_ENV_PROD = process.env.REACT_APP_DEPLOYMENT_ENV === "production";
export const IS_DEPLOYMENT_ENV_STAGING = process.env.REACT_APP_DEPLOYMENT_ENV === "staging";
export const IS_DEPLOYMENT_ENV_TEST = process.env.REACT_APP_DEPLOYMENT_ENV === "test";
export const SUB_ENV = process.env.REACT_APP_SUB_ENVIRONMENT;
export const IS_LOCAL = process.env.REACT_APP_MODE_LOCAL === "true";
export const IS_HEADLESS = process.env.REACT_APP_MODE_HEADLESS === "true";

export const CONSOLE_URL = process.env.REACT_APP_CONSOLE;
export const DOCS_URL = process.env.REACT_APP_DOCS;
export const OPENAPI_URL = process.env.REACT_APP_OPENAPI;
export const MARKETING_URL = process.env.REACT_APP_MAIN_URL;
export const STATUS_URL = process.env.REACT_APP_STATUS;

export const IS_HUBSPOT_INTEGRATION_ENABLED = process.env.REACT_APP_ENABLE_HUBSPOT_INTEGRATION === "true";
export const IS_HUBSPOT_ACCOUNT_CREATED_FLOW_ENABLED =
  process.env.REACT_APP_ENABLE_HUBSPOT_ACCOUNT_CREATED_FLOW === "true";
export const HUBSPOT_SERVICE_URL = process.env.REACT_APP_HUBSPOT_SERVICE;
export const HOTJAR_SITE_ID = process.env.REACT_APP_HOTJAR_SITE_ID;
export const REFERRAL_SERVICE_PARTNER_URL = process.env.REACT_APP_REFERRAL_SERVICE_PARTNER;
export const MARKETPLACE_SERVICE_URL = process.env.REACT_APP_MARKETPLACE_SERVICE;
export const MARKETPLACE_TEMPLATE_REPO = process.env.REACT_APP_MARKETPLACE_TEMPLATE_REPO;
export const MARKETPLACE_BRANCH = process.env.REACT_APP_MARKETPLACE_BRANCH;
export const IS_SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLE === "true";
export const FIREWALL_ALLALLOW_REMOVES_PREV_ITEMS =
  process.env.REACT_APP_FIREWALL_ALLALLOW_REMOVES_PREV_ITEMS === "true";
export const LOCATION_SELECTION_ON_ACCOUNT_CREATE_ENABLED =
  process.env.REACT_APP_ENABLE_LOCATION_SELECTION_ON_ACCOUNT_CREATE === "true";

export const DEPLOYMENT_UPDATE_INTERVAL_MS = Number(process.env.REACT_APP_DEPLOYMENT_UPDATE_INTERVAL_MS);
export const KUBERNETES_READINESS_UPDATE_INTERVAL_MS = Number(
  process.env.REACT_APP_KUBERNETES_READINESS_UPDATE_INTERVAL_MS,
);
export const DOMAIN_UPDATE_INTERVAL_MS = Number(process.env.REACT_APP_DOMAIN_UPDATE_INTERVAL_MS);
export const TOKEN_EXP_CHECK_INTERVAL_MS = Number(process.env.REACT_APP_TOKEN_EXP_CHECK_INTERVAL_MS);
export const METRICS_TOKEN_UPDATE_INTERVAL_MS = Number(process.env.REACT_APP_METRICS_TOKEN_UPDATE_INTERVAL_MS);
export const MK8S_DASHBOARD_TOKEN_UPDATE_INTERVAL_MS = Number(
  process.env.REACT_APP_MK8S_DASHBOARD_TOKEN_UPDATE_INTERVAL_MS,
);
export const REQUEST_REPLICAS_INTERVAL_MS = Number(process.env.REACT_APP_REQUEST_REPLICAS_INTERVAL_MS);
export const VERSION_CHECK_INTERVAL_MS = Number(process.env.REACT_APP_VERSION_CHECK_INTERVAL_MS);
export const AGENT_UPDATE_INTERVAL_MS = Number(process.env.REACT_APP_AGENT_UPDATE_INTERVAL_MS);
export const ALL_DOMAINS_UPDATE_INTERVAL_MS = Number(process.env.REACT_APP_ALL_DOMAINS_UPDATE_INTERVAL_MS);
export const COMMANDS_INTERVAL_MS = Number(process.env.REACT_APP_COMMANDS_INTERVAL_MS);
export const VOLUMESET_UPDATE_INTERVAL_MS = Number(process.env.REACT_APP_VOLUMESET_UPDATE_INTERVAL_MS);

export const STORAGE_KEY_DEFAULT_VARIABLES: string = process.env.REACT_APP_STORAGE_KEY_DEFAULT_VARIABLES as string;
export const STORAGE_KEY_LOG_ORDER_BY: string = process.env.REACT_APP_STORAGE_KEY_LOG_ORDER_BY as string;
export const STORAGE_KEY_LOG_TABLE_TIMESTAMP: string = process.env.REACT_APP_STORAGE_KEY_LOG_TABLE_TIMESTAMP as string;
export const STORAGE_KEY_LOG_TABLE_LABELS: string = process.env.REACT_APP_STORAGE_KEY_LOG_TABLE_LABELS as string;
export const STORAGE_KEY_LOG_TABLE_WRAPPED_LINES: string = process.env
  .REACT_APP_STORAGE_KEY_LOG_TABLE_WRAPPED_LINES as string;
export const STORAGE_KEY_LOG_TABLE_PRETTIFY_JSON: string = process.env
  .REACT_APP_STORAGE_KEY_LOG_TABLE_PRETTIFY_JSON as string;
export const STORAGE_KEY_LOGGED_OUT_STATE = "LOGGED_OUT_STATE";
export const STORAGE_KEY_ORG_TIMEOUT_SECONDS = "ORG_TIMEOUT_SECONDS";

export const SHOW_LEGACY_NEW_SWITCH = process.env.REACT_APP_SHOW_LEGACY_NEW_SWITCH === "true";
export const DEVELOPMENT_NEW_URL = process.env.REACT_APP_DEVELOPMENT_NEW_URL as string;
export const STAGING_NEW_URL = process.env.REACT_APP_STAGING_NEW_URL as string;
export const PRODUCTION_NEW_URL = process.env.REACT_APP_PRODUCTION_NEW_URL as string;

export const DEFAULT_SESSION_TIMEOUT_SECONDS = 15 * 60; // 15 minutes

if (IS_DEVELOPMENT) {
  console.info("env", process.env);
}
